import useNeuroId from './useNeuroId'

export default useNeuroId
